import { styled } from "@mui/material";

import { backAndForth, shine, shineText, sideToSideLeft } from "./animations";

export const ContainerScaled = styled("div")<{ scale: number }>`
	transform: scale(${(props) => props?.scale});
`;

export const ContainerScaledPayment = styled("div")<{
	scale: number;
	step: number;
}>`
	position: relative;
	width: 380px;
	height: ${(props) => (props.step === 1 ? "417px" : "572px")};
	transform: scale(${(props) => props?.scale});
`;

export const Tiki1 = styled("img")`
	width: 100px;
	height: auto;

	@media (orientation: landscape) and (min-width: 1200px) {
		width: 144px;
	}
`;

export const Tiki2 = styled("img")<{ bottom?: string }>`
	position: absolute;
	width: 105px;
	bottom: ${(props) => props.bottom || "8px"};
	left: -14px;
`;

export const Background1 = styled("div")`
	border-radius: 16px;
	border: 1px solid #7a3f1e;
	position: relative;
	background-color: #fffaf1;
	padding: 10px;
	display: flex;
	justify-content: center;
	flex-direction: column;
	gap: 8px;
	width: 226px;
	height: 60px;

	> svg {
		position: absolute;
		left: -7px;
		bottom: 50%;
	}

	/* @media (orientation: landscape) {
		width: 274px;
		height: 34px;
	} */
`;

export const Background2 = styled("div")<{ $backgroundImage: string }>`
	position: relative;
	padding: 15px;
	width: 301px;
	height: 92px;
	background-image: url(${({ $backgroundImage }) => $backgroundImage});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	display: flex;

	> div:first-of-type {
		width: 85px;
	}

	> div:nth-of-type(2) {
		display: flex;
		flex-direction: column;
		gap: 4px;
	}

	.next {
		position: absolute;
		left: 50%;
		bottom: 5%;
		transform: translate(-50%, 50%);
		width: 112px;
	}
	.skip {
		position: absolute;
		right: 0;
		bottom: -25%;
	}
	.to-lp-shop {
		position: absolute;
		left: 50%;
		bottom: 5%;
		transform: translate(-50%, 50%);
		width: 190px;
	}
`;

export const BackgroundPaimentLarge = styled("img")`
	position: absolute;
	top: -25px;
	left: 50%;
	transform: translateX(-50%);
	width: 80%;
`;

export const BackgroundSingleItem = styled("img")`
	position: relative;
	max-width: 156px;
	z-index: -1;
	filter: grayscale(1);
`;

export const Text = styled("p")<{
	fontFamily: "Baloo" | "Inter";
	fontSize: "16px" | "12px";
	fontWeight?: number;
	lineHeight?: "17px" | "15px";
}>`
	margin: 0;
	color: ${(props) => props.color || "#333"};
	font-size: ${(props) => props.fontSize};
	font-family: ${(props) => props.fontFamily};
	font-weight: ${(props) => props.fontWeight || 400};
	line-height: ${(props) => props.lineHeight};
`;

export const Arrow = styled("img")`
	animation: ${backAndForth} 0.5s ease-in-out infinite;

	&.side-to-side-left {
		@media (orientation: landscape) {
			@media (max-height: 599px) {
				animation: ${sideToSideLeft} 0.5s ease-in-out infinite;
			}
		}
	}
`;

export const Shine = styled("img")<{
	position?: string;
	top?: string;
	left?: string;
}>`
	display: none;

	&.animate {
		display: block;
		position: ${(props) => props.position || "absolute"};
		top: ${(props) => props.top || "50%"};
		left: ${(props) => props.left || "50%"};
		opacity: 0.8;
		animation: ${shine} 5s ease-in-out infinite;
		z-index: -1;
	}

	&.animate-on-text {
		display: block;
		position: absolute;
		top: 4px;
		left: 112px;
		opacity: 0.8;
		animation: ${shineText} 5s ease-in-out infinite;
	}
`;
